const route = {
  title: 'My Expenses',
  path: '/my/expenses',
  scopes: ['me.expense'],
  menuGroup: null,
}

export const MyExpensesPage = createPage(route, () => {
  return pug`
    Main
      .min-h-full.p-2.col.center
        Icon.h-20.mb-4.text-red-800.opacity-50(icon='times-circle')
  `
})
